import { combineReducers } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { AuthReducer } from "./auth/Reducers";
import { AutorizacionReducer } from "./autorizacion/Reducers";
import { AseguradoReducer } from "./asegurado/Reducers";
import { PrestadorReducer } from "./prestador/Reducers";
import { ProcedimientoReducer } from "./procedimiento/Reducers";
import { PrecertificacionReducer } from "./precertificacion/Reducers";
import { CatalogoReducer } from "./catalogo/Reducers";
import { VoucherReducer } from "./voucher/Reducers";
import { IngresoReducer } from "./ingreso/Reducers";
import { CoberturaReducer } from "./cobertura/Reduces";
import { UsuariosReducer } from "./usuarios/Reducers";
import { ReportesReducer } from "./reportes/Reducers";

const ingresoPersistConfig = {
  key: "ingreso",
  storage,
  whitelist: ["formHojaQuirurgicaData"]
};

const appReducer = combineReducers({
  auth: AuthReducer,
  autorizacion: AutorizacionReducer,
  asegurado: AseguradoReducer,
  prestador: PrestadorReducer,
  procedimiento: ProcedimientoReducer,
  precertificacion: PrecertificacionReducer,
  catalogo: CatalogoReducer,
  voucher: VoucherReducer,
  ingreso: persistReducer(ingresoPersistConfig, IngresoReducer),
  cobertura: CoberturaReducer,
  usuarios: UsuariosReducer,
  reportes: ReportesReducer,
});

const rootReducer = (state, action) => {
  return appReducer(state, action);
};

export default rootReducer;
